import { io } from "socket.io-client";
import { SocketsUrls } from "../enums/SocketsUrls";
export const socketDeposits = io(SocketsUrls.DEPOSITS, {
	path: "/socket.io",
	secure: true,
	autoConnect: false,
	reconnectionAttempts: 5,
	reconnectionDelay: 1000,
});
